// @core/api/endpoints/secret/get_kv_secret_metadata.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  KvSecretMetadataResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get KV secret metadata
 * Returns secret-level metadata (max_versions, cas_required, custom_metadata) and a list of all versions with their creation times and deletion status.
 */
export async function GetKvSecretMetadata(
  engine_id: string,
  path: string,
  options?: RequestOptions
): Promise<KvSecretMetadataResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/kv/metadata/:path`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':path', encodeURIComponent(path));
  const requestOptions = options;
  return client.get<KvSecretMetadataResponse>(requestPath, { ...requestOptions });
}
